import { AgGridReact } from 'ag-grid-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGenericMasterFilteredListByKey, getleadTotalCount } from '../../redux/selector';
import { fetchLeadsAndAppendToModule } from '../../redux/actions';
import Select from 'react-select';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';

const MemberAccount = ({ module, localData }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const gridRef = useRef();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [deleteData, setDeleteData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [filteredLeadList, setFilteredLeadList] = useState([]);
  const localGridRef = useRef();
  const gridApiRef = useRef(null);
  // Pagination state
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  // Get total record count from Redux
  const leadTotalCount = useSelector(getleadTotalCount);
  // We'll use leadTotalCount for total records rather than filteredLeadList.length.
  const totalRecords = leadTotalCount || 0;
  // When grid is ready, capture the API and update pagination info
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    updatePaginationInfo(params.api);
  };
  // Update pagination info using AgGrid API
  const updatePaginationInfo = (api) => {
    setCurrentPage(api.paginationGetCurrentPage());
    setTotalPages(api.paginationGetTotalPages());
  };
  // When pagination changes, update current page info
  const onPaginationChanged = (params) => {
    if (params.api) {
      updatePaginationInfo(params.api);
    }
  };

  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
  };

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const [rowDataMemberAccount, setRowDataMemberAccount] = useState([]);

  const campaignColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: '',
      width: 20,
      suppressSizeToFit: true,
    },
    {
      headerName: 'Full Name',
      field: 'fullName',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Company Name',
      field: 'companyName',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Email',
      field: 'email',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    // { headerName: "Lead status", field: "leadStatus", width: 150 },
    {
      headerName: 'Phone',
      field: 'phone',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Owner',
      field: 'owner',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Action',
      field: 'action',
      width: 150,
      cellRendererFramework: (params) => {
        const actions = params.data.action.split(',');

        return (
          <div className="action-buttons">
            {actions.includes('view') && (
              <button
                className="action-btn"
                // onClick={() => viewCampaign(params)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3C4.686 3 2.21 4.844 1.254 6.5 2.21 8.156 4.686 10 8 10s5.79-1.844 6.746-3.5C13.79 4.844 11.314 3 8 3zM8 9c-2.607 0-4.788-1.597-5.88-3.68 1.092-2.083 3.273-3.68 5.88-3.68s4.788 1.597 5.88 3.68C12.788 7.403 10.607 9 8 9z" />
                </svg>
              </button>
            )}

            {actions.includes('edit') && (
              <button
                className="action-btn"
                // onClick={() => editCampaign(params)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.146 1.854a2 2 0 0 1 2.828 2.828l-9.708 9.708-2.336.584a1 1 0 0 1-1.215-1.215l.584-2.336 9.708-9.708a2 2 0 0 1 2.828 2.828zM11.5 4.207l-8.5 8.5L2 13.207 10.5 4.707a2 2 0 0 1 2.828 2.828z" />
                </svg>
              </button>
            )}

            {actions.includes('delete') && (
              <button
                className="action-btn"
                // onClick={() => deleteCampaign(params)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V5.5zM14 3a1 1 0 0 0-1-1h-3V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v1h12V3z" />
                </svg>
              </button>
            )}
          </div>
        );
      },
      cellStyle: { textAlign: 'left' },
    },
  ];

  const localLeadColumnDefs = [
    {
      headerName: 'Member Account Name',
      field: 'name',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Industry',
      field: 'industry',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Company LinkedIn',
      field: 'companyLinkedIn',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Website',
      field: 'website',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Phone',
      field: 'phone',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'Annual Revenue',
      field: 'annualRevenue',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    // { headerName: "Owner", field: "owner", width: 150, filter: "agSetColumnFilter" },
  ];

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const onFilterTextBoxChangedForPopup = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box-popup').value);
  }, []);

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closePopup3 = () => {
    setShowPopup3(false);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    const selectedIds = selectedRowsPopup.map((row) => row.id);

    if (formData.type === 'edit') {
      const data = {
        ...formData,
        moduleId: formData.id,
        campaignId: localData.id,
        module: 'Lead',
      };

      await apiServices
        .updateCampaignByModule(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup2(false);
            dispatch(
              fetchLeadsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Lead Updated Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error updating leads:', error);
          toast.error('Failed to update leads.', { position: 'top-right' });
        });
    } else {
      const data = {
        ...formData,
        leadId: selectedIds,
        campaignId: [localData.id],
      };

      await apiServices
        .addCampaignFromLead(data)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRowsPopup([]);
            handleClose();
            dispatch(
              fetchLeadsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Lead Added Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding leads:', error);
          toast.error('Failed to add leads.', { position: 'top-right' });
        });
    }

    // }

    setLoading(false);
    setFormData([]);
  };

  const handleClickDeleteLead = (paramsValue) => {
    setLoading(true);
    const selectedIds = selectedRows.map((row) => row.id);
    // Creating the desired JSON object
    const data = {
      campaignId: localData.id,
      module: 'Lead',
      moduleId: selectedRows ? selectedIds : [paramsValue?.id],
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          setShowPopup3(false);
          setSelectedRows([]);
          dispatch(
            fetchLeadsAndAppendToModule({
              moduleName: module,
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Lead UnAssigned Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while UnAssigning lead:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (localData?.id) {
      setLoading(true);
      const data = { id: localData?.id };
      apiServices
        .getChildAccountByParentAccountId(data)
        .then((response) => {
          if (response.status === 200) {
            const contactList = response.data.account;
            setRowDataMemberAccount(contactList);
            setLoading(false);
          } else {
            console.error('Error fetching user timelog settings:', response?.status);
          }
        })
        .catch((error) => {
          console.error('Error fetching user timelog settings:', error);
        });
    }
  }, [localData?.id]);

  useEffect(() => {
    const plannedOption = memberStatus?.find((option) => option.displayName === 'Planned');

    if (plannedOption) {
      setSelectedOptions((prevState) => ({
        ...prevState,
        memberStatusId: plannedOption.id,
      }));

      setFormData((prevState) => ({
        ...prevState,
        memberStatus: plannedOption.id,
        memberStatusId: plannedOption.displayName,
      }));
    }
  }, [memberStatus, showPopup2]);

  return (
    <div className="row" id="campainview">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/memberAccountIcon.svg" alt="" />
              Member Account({rowDataMemberAccount.length})
            </label>

            <span></span>
          </div>
          <div className="leadcontent">
            <div className="row">
              <div className="col-12 col-md-12">
                <div id="view_leadtable">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search in Member Accounts..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div className="cutome_ag_theme" style={{ marginTop: '1rem' }} id="withFilter">
                    <div className="ag-theme-balham tbl_height">
                      <AgGridReact
                        rowData={rowDataMemberAccount}
                        columnDefs={localLeadColumnDefs}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        rowSelection="multiple"
                        sideBar={sideBar}
                        onSelectionChanged={onSelectionChanged}
                        alwaysShowVerticalScroll={true}
                        ref={localGridRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isOpen && (
            <div className="popup-backdrop">
              <div className="popup">
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">Add Leads to Campaign : {localData?.campaignName}</h4>
                  <button className="view-close" onClick={handleClose}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693274 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM20.055 21.8L16 17.745L11.945 21.8C11.8318 21.9186 11.6961 22.0135 11.5457 22.0789C11.3954 22.1443 11.2335 22.179 11.0695 22.1809C10.9056 22.1828 10.7429 22.152 10.591 22.0901C10.4392 22.0283 10.3012 21.9367 10.1853 21.8207C10.0693 21.7048 9.97775 21.5668 9.9159 21.415C9.85404 21.2631 9.82317 21.1005 9.8251 20.9365C9.82704 20.7725 9.86173 20.6106 9.92714 20.4603C9.99255 20.3099 10.0874 20.1742 10.206 20.061L14.261 16.006L10.206 11.951C9.9843 11.7186 9.8623 11.4087 9.86608 11.0875C9.86986 10.7663 9.99913 10.4594 10.2263 10.2322C10.4534 10.0051 10.7603 9.87586 11.0815 9.87207C11.4027 9.86829 11.7126 9.99029 11.945 10.212L16 14.267L20.055 10.212C20.2874 9.99029 20.5973 9.86829 20.9185 9.87207C21.2397 9.87586 21.5466 10.0051 21.7738 10.2322C22.0009 10.4594 22.1301 10.7663 22.1339 11.0875C22.1377 11.4087 22.0157 11.7186 21.794 11.951L17.739 16.006L21.794 20.061C22.0233 20.2923 22.152 20.6048 22.152 20.9305C22.152 21.2562 22.0233 21.5687 21.794 21.8C21.6802 21.915 21.5447 22.0063 21.3953 22.0685C21.2459 22.1307 21.0857 22.1626 20.9239 22.1623C20.7621 22.162 20.6019 22.1296 20.4528 22.0669C20.3036 22.0042 20.1684 21.9124 20.055 21.797V21.8Z"
                        fill="#456ABB"
                      />
                    </svg>
                  </button>
                </div>
                {/* Popup Body */}
                <div className="popup-body">
                  <div className="popupbody_header">
                    <div className="hd_leftview">
                      <div className="timetrack_searcharea">
                        <input
                          type="text"
                          className="search_field"
                          id="filter-text-box-popup"
                          placeholder="Search..."
                          onInput={onFilterTextBoxChangedForPopup}
                        />
                        <i className="icon_tt"></i>
                      </div>
                      <div className="flx_heding view_fnt" id="action_dropdown">
                        <label htmlFor="memberStatusId" style={{ width: '100px' }}>
                          Member Status:
                        </label>
                        <Select
                          value={selectedOptions.memberStatus}
                          placeholder={formData.memberStatusId}
                          onChange={(selectedOption) =>
                            handleChange(selectedOption, 'memberStatusId')
                          }
                          options={memberStatus?.map((data) => ({
                            value: data.id,
                            label: data.displayName,
                          }))}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: '200px',
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: '9999',
                              height: '200px',
                              overflow: 'auto',
                              color: '#000',
                            }),
                            control: (base) => ({
                              ...base,
                              borderRadius: '50px',
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="hd_rightview" id="update_campaign">
                      <div className="flx_heding view_fnt">
                        <label>
                          Total Records: <span>{filteredLeadList.length}</span>
                        </label>
                      </div>
                      <span className="separator"></span>
                      <div className="flx_heding">
                        <button
                          className="add-btn"
                          type="button"
                          onClick={() => handleSubmit(formData)}
                          disabled={!selectedRowsPopup.length > 0}
                        >
                          Add to Campaign
                        </button>
                      </div>

                      {/* Popup 2 Overlay */}
                    </div>
                  </div>
                  <div id="view_leadtable">
                    <div
                      className="ag-theme-balham"
                      style={{
                        height: 250,
                        width: '100%',
                        margin: '1rem auto',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '10px',
                      }}
                    >
                      <AgGridReact
                        rowData={filteredLeadList}
                        columnDefs={campaignColumnDefs}
                        frameworkComponents={frameworkComponents}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        sideBar={sideBar}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChangedPopup}
                        ref={gridRef}
                        onGridReady={onGridReady}
                        onPaginationChanged={onPaginationChanged}
                        pagination={true}
                        paginationPageSize={pageSize}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup2 && (
            <div className="popup-backdrop">
              <div className="popup-overlay">
                <div className="popup" style={{ width: '50%' }}>
                  {/* Popup Header */}
                  <div className="popup-header">
                    <h4 className="popup-title">Update Campaign Member Status</h4>
                    <button className="close-btn" onClick={closePopup2}>
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693274 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM20.055 21.8L16 17.745L11.945 21.8C11.8318 21.9186 11.6961 22.0135 11.5457 22.0789C11.3954 22.1443 11.2335 22.179 11.0695 22.1809C10.9056 22.1828 10.7429 22.152 10.591 22.0901C10.4392 22.0283 10.3012 21.9367 10.1853 21.8207C10.0693 21.7048 9.97775 21.5668 9.9159 21.415C9.85404 21.2631 9.82317 21.1005 9.8251 20.9365C9.82704 20.7725 9.86173 20.6106 9.92714 20.4603C9.99255 20.3099 10.0874 20.1742 10.206 20.061L14.261 16.006L10.206 11.951C9.9843 11.7186 9.8623 11.4087 9.86608 11.0875C9.86986 10.7663 9.99913 10.4594 10.2263 10.2322C10.4534 10.0051 10.7603 9.87586 11.0815 9.87207C11.4027 9.86829 11.7126 9.99029 11.945 10.212L16 14.267L20.055 10.212C20.2874 9.99029 20.5973 9.86829 20.9185 9.87207C21.2397 9.87586 21.5466 10.0051 21.7738 10.2322C22.0009 10.4594 22.1301 10.7663 22.1339 11.0875C22.1377 11.4087 22.0157 11.7186 21.794 11.951L17.739 16.006L21.794 20.061C22.0233 20.2923 22.152 20.6048 22.152 20.9305C22.152 21.2562 22.0233 21.5687 21.794 21.8C21.6802 21.915 21.5447 22.0063 21.3953 22.0685C21.2459 22.1307 21.0857 22.1626 20.9239 22.1623C20.7621 22.162 20.6019 22.1296 20.4528 22.0669C20.3036 22.0042 20.1684 21.9124 20.055 21.797V21.8Z"
                          fill="#456ABB"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* Popup Body */}
                  <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="input-container">
                          <label htmlFor="memberStatusId">Member Status</label>
                          <Select
                            value={selectedOptions.memberStatusId}
                            placeholder={editData.memberStatus || 'Select Status'}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'memberStatusId')
                            }
                            options={memberStatus?.map((data) => ({
                              value: data.id,
                              label: data.displayName,
                            }))}
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '100%',
                                zIndex: '9999',
                              }),
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                border: state.isFocused ? '2px solid #365397' : '1px solid #ccc',
                                boxShadow: state.isFocused ? '0 0 5px #365397' : 'none', // Focus shadow
                                transition: 'border-color 0.3s, box-shadow 0.3s',
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: '99999', // Dropdown z-index
                                maxHeight: '150px', // Limit dropdown height
                                overflowY: 'auto', // Scroll if items exceed height
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: '99999', // Rendered dropdown above everything
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused
                                  ? '#365397' // Hover background
                                  : state.isSelected
                                    ? 'rgba(54, 83, 151, 0.2)' // Selected background
                                    : '#fff', // Default background
                                color: state.isFocused || state.isSelected ? '#fff' : '#000', // Text color
                                cursor: 'pointer',
                                transition: 'background-color 0.3s, color 0.3s',
                              }),
                              singleValue: (base) => ({
                                ...base,
                                padding: '5px',
                                borderRadius: '3px',
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Popup Footer */}
                  <div className="popup-footer" id="unassign-popup">
                    <button className="cancel-lead ld-btn" onClick={closePopup2}>
                      Cancel
                    </button>
                    <button
                      className="save-lead ld-btn"
                      onClick={() =>
                        handleSubmit({
                          ...formData,
                          id: editData.id,
                          type: 'edit',
                        })
                      }
                    >
                      Save
                    </button>

                    {/* Popup 3 Overlay */}
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup3 && (
            <div id="unassign-popup">
              <div className="popup-overlay">
                <div
                  className="popup"
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    padding: '20px',
                    zIndex: '9999',
                    background: 'white',
                  }}
                >
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="unassign-txt">
                          <p>
                            Unassign {deleteData.firstName} {deleteData.middleName}{' '}
                            {deleteData.lastName} from {localData.campaignName}?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Popup Footer */}
                  <div className="unassign-footer">
                    <button className="cancel-lead ld-btn" onClick={closePopup3}>
                      Cancel
                    </button>
                    <button
                      className="unassign-lead ld-btn"
                      onClick={() => handleClickDeleteLead(deleteData)}
                    >
                      Unassign
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberAccount;
